import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=1d1ea11c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1ea11c')) {
      api.createRecord('1d1ea11c', component.options)
    } else {
      api.reload('1d1ea11c', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=1d1ea11c", function () {
      api.rerender('1d1ea11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/TheFooter.vue"
export default component.exports